import { Link } from 'react-router-dom';
import Logo from '../base/Logo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white">
      <div className="w-full px-6 py-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {/* Coluna 1 - Logo */}
            <div>
              <Logo variant="light" size="sm" className="mb-4" />
              <p className="text-gray-400 text-xs leading-relaxed">
                Portal especializado em gestão de ativos e compliance contábil.
              </p>
            </div>

            {/* Coluna 2 - Categorias */}
            <div>
              <h4 className="text-white text-sm font-bold uppercase mb-4">Categorias</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/categoria/ativo-fixo-patrimonio" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Ativo Fixo
                  </Link>
                </li>
                <li>
                  <Link to="/categoria/controle-estoques-mro" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Estoques & MRO
                  </Link>
                </li>
                <li>
                  <Link to="/categoria/inventarios-auditorias" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Inventários
                  </Link>
                </li>
                <li>
                  <Link to="/categoria/tecnologia" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Tecnologia
                  </Link>
                </li>
                <li>
                  <Link to="/categoria/compliance-ifrs" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Compliance
                  </Link>
                </li>
              </ul>
            </div>

            {/* Coluna 3 - Recursos */}
            <div>
              <h4 className="text-white text-sm font-bold uppercase mb-4">Recursos</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/ebooks" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    E-books
                  </Link>
                </li>
                <li>
                  <Link to="/webinars" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Webinars
                  </Link>
                </li>
                <li>
                  <Link to="/cases" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Cases
                  </Link>
                </li>
                <li>
                  <Link to="/glossario" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Glossário
                  </Link>
                </li>
              </ul>
            </div>

            {/* Coluna 4 - Empresa */}
            <div>
              <h4 className="text-white text-sm font-bold uppercase mb-4">Empresa</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/sobre" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Sobre Nós
                  </Link>
                </li>
                <li>
                  <Link to="/contato" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Contato
                  </Link>
                </li>
                <li>
                  <Link to="/privacidade" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Privacidade
                  </Link>
                </li>
                <li>
                  <Link to="/termos" className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer">
                    Termos de Uso
                  </Link>
                </li>
              </ul>
            </div>

            {/* Coluna 5 - Social */}
            <div>
              <h4 className="text-white text-sm font-bold uppercase mb-4">Siga-nos</h4>
              <div className="flex items-center gap-3 mb-4">
                <a 
                  href="https://linkedin.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-[#CC0000] transition-all cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-sm"></i>
                </a>
                <a 
                  href="https://twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-[#CC0000] transition-all cursor-pointer"
                >
                  <i className="ri-twitter-x-fill text-sm"></i>
                </a>
                <a 
                  href="https://youtube.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-[#CC0000] transition-all cursor-pointer"
                >
                  <i className="ri-youtube-fill text-sm"></i>
                </a>
              </div>
              <p className="text-gray-400 text-xs">
                contato@ativonews.com.br
              </p>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-white/10 mt-8 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-xs">
              © {currentYear} Ativo News. Todos os direitos reservados.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 text-xs hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
